import { Box } from "@chakra-ui/react";
import { CtaButton, DiscordMark } from "@/components";
import { DISCORD_CTA_LABEL, DISCORD_INVITE_URL } from "@/content";

export const DiscordCta = () => (
  <CtaButton
    href={DISCORD_INVITE_URL}
    external
    aria-label={DISCORD_CTA_LABEL}
    className="print-hide"
    variant="brand"
    size="nav"
    bg="discord.500"
    _hover={{ bg: "discord.600", color: "ink.light" }}
    position="fixed"
    right="clamp(16px, 3vw, 28px)"
    bottom="clamp(16px, 3vw, 28px)"
    zIndex={90}
    px={{ base: "13px", md: "20px" }}
    borderRadius="full"
    boxShadow="0 14px 32px -14px rgba(0, 0, 0, 0.5)"
  >
    <DiscordMark boxSize="20px" />
    <Box as="span" display={{ base: "none", md: "inline" }}>
      {DISCORD_CTA_LABEL}
    </Box>
  </CtaButton>
);
